
<template>
  <v-container v-if="permitted == false && permitted != null" class="pt-0" fluid>
    <v-dialog v-model="permitted_dialog" max-width="400px">
      <v-card>
        <v-card-text>
          <div class="text-center">
            <div class="title font-weight-light pt-2"><v-icon class="mr-1">mdi-shield-lock-outline</v-icon>Security Error</div>
            <p>{{message}}</p>
            <v-progress-circular
              :size="70"
              :width="2"
              :value="100"
              color="error"
              class="mb-4 mr-4"
            >
              <v-icon color="red" x-large>mdi-exclamation-thick</v-icon>
            </v-progress-circular>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
  <v-container v-else v-show="permitted != null" class="pt-0" fluid>
    <v-snackbar
      :value="showMessage()"
      multi-line
      color="#686868"
      top
      
    >
      {{message}}
    </v-snackbar>
    <v-card flat >
    <v-toolbar dense flat color="#2A353D">
      <v-toolbar-title class="white--text subtitle-1 font-weight-normal">{{heading}}</v-toolbar-title>
      <v-spacer/>
      <v-btn fab x-small outlined color="#81DBF6" class="mr-1" v-if="edit == true || create == true" @click="view = false; closeCreate(); closeEdit()"><v-icon>mdi-chevron-left</v-icon></v-btn>
      <v-btn fab x-small outlined color="#81DBF6" @click="$router.push('/Home')"><v-icon>mdi-close</v-icon></v-btn>

      <v-progress-linear
        :active="loading"
        :indeterminate="loading"
        absolute
        bottom
        color="#81DBF6"
      ></v-progress-linear>
    </v-toolbar>
    </v-card>

    <v-alert
      class="my-2"
      dense text
      color="#2A353D"
    >
      <v-row align="center" class="mx-2">
        <v-col class="py-0">
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="parameters.Year"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="parameters.Year"
                class="mx-1"
                label="Year"
                append-icon="mdi-calendar-month"
                readonly placeholder="--/--/--"
                hide-details
                dense filled rounded background-color="white" color="#2A353D"
                :rules="TextFieldRules"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker color="#2A353D" @input="save" reactive ref="picker" v-model="parameters.Year" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn outlined small color="#2A353D" @click="menu = false">Cancel</v-btn>
            <v-btn outlined small color="#2A353D" @click="$refs.menu.save(parameters.Year)">OK</v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col class="py-0">
          <v-select
            @change="getPerformance()"
            filled rounded background-color="white" dense clearable
            hide-details
            v-model="parameters.AccountID"
            :items="Accounts.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
            class="mx-1"
            :item-text="item => item.tblclient.Forename + ` ` + item.tblclient.MajorName +` - ` + item.AccountNumber"
            item-value="AccountID"
            placeholder="----"
            :rules="TextFieldRules"
            label="Account"
          ></v-select>
        </v-col>
      </v-row>
    </v-alert>

    <v-data-table
      :fixed-header="true"
      :headers="headers"
      :items="asset_performance"
      :search="search"
      :height="520"
      hide-default-footer
      disable-pagination
      @current-items="getFiltered"
      class="elevation-12 mt-2"
    >

      <template v-slot:top>
        <v-container row>
          <v-text-field
            class="ml-3"
            hide-details
            outlined
            placeholder="search..."
            v-model="search"
            append-icon="mdi-magnify"
            dense
          ></v-text-field>

          <v-spacer></v-spacer>

          <v-menu open-on-hover offset-y>
            <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" outlined small color="#2A353D" class="ml-2">
              EXPORT<v-icon class="ml-1" small>mdi-exit-to-app</v-icon>
            </v-btn>
            </template>
            <v-list dense>
            <v-list-item class="ma-0 pa-0">
              <v-btn @click="generatePDF(false)" text small color="#2A353D">
                <v-icon class="mr-1" small>mdi-file-pdf-box</v-icon>TO PDF
              </v-btn>
            </v-list-item>
            <v-list-item class="ma-0 pa-0">
              <v-btn text small color="#2A353D">
                <download-excel
                  :data   = "CurrentPerformance"
                  type    = "xls"
                  name    = "Asset Perfomance Report.xls">

                  <v-icon class="mr-1" small>mdi-microsoft-excel</v-icon>TO EXCEL
                </download-excel>
              </v-btn>
            </v-list-item>
            <v-list-item class="ma-0 pa-0">
              <v-btn text small color="#2A353D">
                <download-excel
                  :data   = "CurrentPerformance"
                  type    = "csv"
                  name    = "Asset Perfomance Report.csv">

                  <v-icon class="mr-1" small>mdi-file-document-outline</v-icon>TO CSV
                </download-excel>
              </v-btn>
            </v-list-item>
            </v-list>
          </v-menu>
          <v-btn @click="generatePDF(true)" outlined small color="#2A353D" class="ml-2" v-on="on">
            PRINT<v-icon class="ml-1" small>mdi-printer</v-icon>
          </v-btn>
        </v-container>
        <span class="ml-4 grey--text subtitle-1 font-weight-normal">Fund: {{asset_performance.map(a => a.FundName)[0]}}</span>
        <!-- <span v-if="performance[0].ClientName" class="ml-4 grey--text subtitle-1 font-weight-normal">Client Name: {{performance[0].ClientName}}</span> -->
      </template>

    </v-data-table>
  </v-container>
</template>

<script>
import reportsService from '../services/reports.service';
import UserService from '../services/user.service';
import {mapGetters} from "vuex";
import jsPDF from 'jspdf';
import 'jspdf-autotable'

export default {
  data () {
    return {
      parameters: {},
      asset_performance: [],
      CurrentPerformance: [],
      valid: true,
      loading: false,
      filter_dialog: false,
      search: '',
      message: '',
      menu: false,
      heading: "Performance for Assets Report",
      menu2: false,
      permitted: null,
      permitted_dialog: true,
      headers: [
        { text: 'Asset', value: 'AssetName', sortable: false, width: 200 },
        { text: 'Q1Prtfolio', value: 'Q1Prtfolio', sortable: false },
        { text: 'Q1NetIP', value: 'Q1NetIP', sortable: false},
        { text: 'Q2Prtfolio', value: 'Q2Prtfolio', sortable: false},
        { text: 'Q2NetIP', value: 'Q2NetIP', sortable: false },
        { text: 'Q3Prtfolio', value: 'Q3Prtfolio', sortable: false},
        { text: 'Q3NetIP', value: 'Q3NetIP', sortable: false },
        { text: 'Q4Prtfolio', value: 'Q4Prtfolio', sortable: false},
        { text: 'Q4NetIP', value: 'Q4NetIP', sortable: false },
      ],
    }
  },

  watch: {
    menu (val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    'parameters.Year': {
      handler: function(newValue) {
        if(newValue != null && newValue != ''){
          this.getPerformance()
        }
      },
      deep: true
    },
  },

  computed: {
    ...mapGetters([
      "currentImage",
      "allCustodians",
      "allCurrencies",
      "identity",
      "allCountries",
      "allCities",
      "currentSystemDate",
      "allClientAccounts",
      "allCounters"
    ]),

    currentUser() {
      return this.$store.state.auth.user;
    },

    Accounts(){
      return this.allClientAccounts
    }
  },

  created(){
    this.parameters = {
      Year: this.currentSystemDate.DayDate.split('-')[0],
      AccountID: 0,
    }
    this.loading = true,
    reportsService.getAssetPerformance(this.parameters)
    .then(response => {
      this.asset_performance = response.data;
      this.loading = false
    },
    error => {
    this.message =
      (error.response && error.response.data.message) ||
      error.message ||
      error.toString();
      this.loading = false
    })
  },

  methods: {
    async getPerformance() {
      this.message = ''
      if(this.parameters.Year == null || this.parameters.Year == ''){
        this.parameters.Year = this.currentSystemDate.DayDate.split('-')[0]
      } else {
        this.parameters.Year = this.parameters.Year.substring(0, 4)
      }
      if(this.parameters.AccountID == null || this.parameters.AccountID == ''){
        this.parameters.AccountID = 0
      }
      this.loading = true,
      reportsService.getAssetPerformance(this.parameters)
      .then(response => {
        this.asset_performance = response.data;
        this.filter_dialog = false;
        this.loading = false;
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
        this.filter_dialog = false;
        this.loading = false;
      })
    },
    generatePDF(IsPrint) {
      const columns = [
        { title: 'Asset', dataKey: 'AssetName' },
        { title: 'Q1Prtfolio', dataKey: 'Q1Prtfolio' },
        { title: 'Q1NetIP', dataKey: 'Q1NetIP' },
        { title: 'Q2Prtfolio', dataKey: 'Q2Prtfolio' },
        { title: 'Q2NetIP', dataKey: 'Q2NetIP' },
        { title: 'Q3Prtfolio', dataKey: 'Q3Prtfolio' },
        { title: 'Q3NetIP', dataKey: 'Q3NetIP' },
        { title: 'Q4Prtfolio', dataKey: 'Q4Prtfolio' },
        { title: 'Q4NetIP', dataKey: 'Q4NetIP' },
      ];

      const addFooters = doc => {
        const pageCount = doc.internal.getNumberOfPages()

        for (var i = 1; i <= pageCount; i++) {
          var imgData = 'data:image/png;base64,'+ this.currentImage[0].data;

          doc.addImage(imgData, 'PNG', 0.5, 0.28, 1.3, 0.7);
          doc.setPage(i)
          // text is placed using x, y coordinates
          doc.setFontSize(10).text(this.identity[0].OrgName, 8.5, 0.5);
          doc.setFontSize(6).text(this.identity[0].Phadd1, 8.5, 0.6);
          doc.setFontSize(6).text(this.allCities.filter(a => a.CityID == this.identity[0].PhCity).map(a => a.City)[0], 8.5, 0.7);
          doc.setFontSize(6).text(this.allCountries.filter(a => a.CountryId == this.identity[0].PhCountry).map(a => a.CountryName)[0], 8.5, 0.8);
          doc.setFontSize(6).text('email: ' + this.identity[0].OrgMail, 8.5, 0.9);
          doc.setFontSize(6).text('cell: ' + this.identity[0].OrgNumber, 8.5, 1.0);
          doc.setFontSize(10).text(this.heading, 0.5, 1.2);
          doc.setFontSize(8).text('Fund: ' + this.CurrentPerformance.map(a => a.FundName)[0] + '        ' + (this.parameters.AccountID > 0? 'Client: ' + this.Accounts.filter(a => a.AccountID == this.parameters.AccountID).map(a => a.tblclient.Forename) + ' ' + this.Accounts.filter(a => a.AccountID == this.parameters.AccountID).map(a => a.tblclient.MajorName) + '        ' : '') + (this.parameters.Year > 0? 'Year: ' + this.parameters.Year : ''), 0.5, 1.4);
          // create a line under heading
          doc.setLineWidth(0.01).line(0.5, 1.5, 10.5, 1.5);
          doc.setLineWidth(0.01).line(0.5, 1.7, 10.5, 1.7);
          doc.setFontSize(6).text('Page ' + String(i) + ' of ' + String(pageCount), 4.3, 10.7, {
            align: 'center'
          })
        }
      }

      let doc = new jsPDF({
        orientation: "landscape",
        unit: "in",
        format: "letter"
      });

      doc.setFont('helvetica');
      doc.setFontSize(5);
      doc.autoTable({
        columns,
        body: this.CurrentPerformance,
        margin: { left: 0.5, top: 1.5 },
        styles: {overflow: 'linebreak',
                fontSize: 6},
        showHeader: 'everyPage',
        theme: 'plain'
      });
      addFooters(doc);
      if(IsPrint == true){
        doc.output('dataurlnewwindow');
      } else{
        doc.save('Asset Perfomance Report.pdf')
      }
    },
    save (date) {
      this.$refs.menu.save(date.split('-')[0]);
      this.$refs.picker.activePicker = 'YEAR'
      this.menu = false;
    },
    getFiltered(current){
      this.CurrentPerformance = current;
    },
    showMessage(){
      if(this.message){
        return true
      } else {
        return false
      }
    },
    validate () {
      this.$refs.form.validate()
      return this.valid
    },

    reset () {
      this.$refs.form.reset()
    },
  },

  mounted () {
    UserService.isReports().then(
      () => {
        this.permitted = true;
        this.message = '';
      },
      error => {
        this.permitted = false;
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  }
}
</script>

<style scoped>
.v-btn {
  outline: none
}
</style>